<div class="card mb-0">
  <div class="card-header p-2">
    <div class="row">
      @if (isOwner) {
        <div class="col-sm-auto">
          <div>
            <button type="button" (click)="openAddEditMember(null)" class="btn btn-success add-btn me-1" [disabled]="current_client.plan === null">
              <i class="ri-add-line align-bottom me-1"></i> Assign User </button>
            </div>
          </div>
        }
        <div class="col-sm">
          <div class="d-flex justify-content-sm-end">
            <div class="search-box me-2">
              <input type="text" class="form-control search" placeholder="Search..." [(ngModel)]="searchText" (input)="onSearch()">
              <i class="ri-search-line search-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body pb-2">
      <div class="table-responsive table-card">
        <table class="table">
          <thead>
            <tr class="bg-light text-muted">
              <th scope="col" style="width: 50px;">No.</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Roles</th>
              @if (isOwner) {
                <th>Action</th>
              }
            </tr>
          </thead>
          <tbody>
            @if (loading) {
              <tr>
                <td [attr.colspan]="colspan" class="text-center">
                  <app-loading-spinner></app-loading-spinner>
                </td>
              </tr>
            }
            @if (!loading && members && members.length > 0) {
              @for (member of members; track member; let i = $index) {
                <tr>
                  <td>{{ (i + 1) | number:'2.0-0' }}</td>
                  <td>
                    <ngb-highlight [result]="member.user_details.first_name" [term]="searchText"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="member.user_details.last_name" [term]="searchText"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="member.user_details.email" [term]="searchText"></ngb-highlight>
                  </td>
                  <td class="status">
                    @for (role of member.roles; track role) {
                      <span
                        class="badge text-uppercase me-1"
                        [ngClass]="role === 'ADMIN' ? 'bg-danger-subtle text-danger' : role === 'EDITOR' ? 'bg-warning-subtle text-warning' : 'bg-success-subtle text-success'">
                        {{ role }}
                      </span>
                    }
                  </td>
                  @if (isOwner) {
                    <td>
                      @if (current_client?.id !== member.client_user_id) {
                        <div class="d-flex gap-2">
                          <div class="edit">
                            <button (click)="openAddEditMember(member)" class="btn btn-sm btn-info edit-item-btn" ngbTooltip="Edit User" alt="Edit User">
                              <i class="ri-pencil-line align-middle"></i>
                            </button>
                          </div>
                          <div class="remove">
                            <button (click)="openRemoveMemberModal(member)" class="btn btn-sm btn-danger remove-item-btn" ngbTooltip="Remove User" alt="Remove User">
                              <i class="ri-delete-bin-line align-middle"></i>
                            </button>
                          </div>
                        </div>
                      }
                    </td>
                  }
                </tr>
              }
            }
            @if (!loading && members && members.length === 0) {
              <tr>
                <td [attr.colspan]="colspan" class="text-center">No assessments found.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (!loading && members && members.length > 0) {
        <div class="row justify-content-md-between align-items-md-center mt-2">
          <div class="col col-sm-6">
            <div class="dataTables_info" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{totalMembers}} entries </div>
          </div>
          <div class="col col-sm-6">
            <div class="text-sm-right float-end listjs-pagination">
              <ngb-pagination [collectionSize]="totalMembers" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getDetails()"></ngb-pagination>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <ng-template #addMemberModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Add Subject File Member</h5>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="addMemberForm" (ngSubmit)="onSubmit()">

        <div class="mb-3">
          <label for="client_user_id" class="form-label">Member <span class="text-danger">*</span></label>
          @if (!isEditMode) {
            <ng-select
              [loading]="usersLoading"
              [items]="users"
              id="client_user_id"
              bindValue="client_user_id"
              placeholder="Select Subject File Owner"
              formControlName="client_user_id"
              (search)="onSearchUser($event)"
              [searchFn]="customSearchFn"
              [ngClass]="{ 'is-invalid': submitted && addMemberForm.get('client_user_id')?.errors }">
              <ng-template ng-label-tmp let-item="item">
                {{ item.user_details.first_name }} {{ item.user_details.last_name }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.user_details.first_name }} {{ item.user_details.last_name }}
                <small class="text-muted d-block">{{ item.user_details.email }}</small>
              </ng-template>
              <ng-template ng-loadingspinner-tmp>
                <div class="d-flex justify-content-center py-2 px-2">
                  <div class="spinner-border spinner-border-sm text-warning" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          }
          @if (isEditMode) {
            <input type="text" class="form-control" [value]="selectedMemberName" readonly disabled>
          }
        </div>

        <div class="mb-3">
          <label for="roles" class="form-label">Roles <span class="text-danger">*</span></label>
          <ng-select [items]="displayableRoles" [multiple]="true" bindLabel="name" bindValue="code" placeholder="Select Roles" formControlName="roles" [ngClass]="{ 'is-invalid': submitted && addMemberForm.get('roles')?.errors }">
          </ng-select>
          <div class="invalid-feedback"> Please select at least one role </div>
        </div>

        <div class="text-end">
          <button type="button" class="btn btn-light me-2" (click)="modal.dismiss()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="spinner">
            @if (spinner) {
              <span class="spinner-border spinner-border-sm me-1"></span>
            }
            {{ isEditMode ? 'Save Changes' : 'Add Member' }}
          </button>
        </div>

      </form>
    </div>
  </ng-template>

  <ng-template #successModal let-modal>
    <div class="modal-content">
      <div class="modal-body text-center p-5">
        <div class="text-end">
          <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="mt-2">
          @if (success) {
            <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
          }
          @if (!success) {
            <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
          }
          <h4 class="mb-3 mt-4">{{ title }}</h4>
          <p class="text-muted mx-4 mb-0">{{ message }}</p>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #removeMemberModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you sure you want to remove</h4>
            <h4><span class="fw-semibold text-warning">{{ selectedMemberName }}</span>?</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
          <button type="button" class="btn w-sm btn-danger btn-load" (click)="removeMember()">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, I'm sure!</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>